import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { Cluster, Stack } from 'component-library-next'

import { useIntl } from '@app/intl/Intl'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { Button } from '@app/lib/inputs/Button/Button'
import { CourtCaseStatePicker } from '@app/modules/CourtCasesTables/Components/CourtCaseStatePicker'

import { CourtCasesFilterValues } from '../hooks/useCourtCasesTable'

export type CourtCaseTasksFilterProps = {
  initialValues: Partial<CourtCasesFilterValues>
  onSubmit: (values: Partial<CourtCasesFilterValues>) => void
}

export const CourtCasesFilterForm = ({ onSubmit, initialValues }: CourtCaseTasksFilterProps) => {
  const { formatMessage } = useIntl()
  const methods = useForm<CourtCasesFilterValues>({ defaultValues: initialValues })

  const handleSubmit = (values: CourtCasesFilterValues) => {
    onSubmit(values)
  }

  const handleReset = () => {
    methods.reset({})
    onSubmit({})
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <Stack>
          <InputField
            name='state'
            label={formatMessage({ id: 'CourtCasesTables.Filter.State' })}
            render={({ inputProps }) => {
              return <CourtCaseStatePicker {...inputProps} />
            }}
          />
          <Cluster justification={Cluster.justification.right} gap={Cluster.gap.small}>
            <Button variant='outlined' color='neutral' type='reset' onClick={handleReset}>
              {formatMessage({ id: 'CourtCasesTables.Filter.Btn.Reset' })}
            </Button>
            <Button variant='solid' color='primary' type='submit'>
              {formatMessage({ id: 'CourtCasesTables.Filter.Btn.Filter' })}
            </Button>
          </Cluster>
        </Stack>
      </form>
    </FormProvider>
  )
}
